
<div id="dashboard" class="container-fluid mt-3">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box">
        <div class="page-title-right">
          <a href="{{config.applicationSettings.manualUser}}" class="guida btn btn-info fw-bold">
            <i class="dripicons-information me-1"></i> Guida
          </a>
        </div>
        <h3 class="page-title">Siti Contaminati</h3>
        <p>Logout successful</p>
      </div>
    </div>
  </div>
</div>



